<template>
  <v-col>
    <v-row
      v-if="hasCustomRoleAdmin"
      class="justify-center align-start"
    >
      <v-col>
        <v-row class="justify-space-between px-2">
          <v-col class="col-auto">
            <span class="headline font-weight-bold">Settings</span>
          </v-col>

          <v-col class="col-auto">
            <v-row>
              <v-col>
                <!-- Button -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <v-divider />
          </v-col>
        </v-row>

        <v-row>
          <!-- Navigation -->
          <v-col
            class="col-auto"
            style="min-width: 300px;"
          >
            <v-row>
              <v-col>
                <v-card class="elevation-0">
                  <v-card-title>
                    <v-col class="py-0">
                      <span class="subtitle-2">Account</span>
                    </v-col>
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col class="pt-0">
                        <v-row
                          v-if="allowedRoutes.includes('dashboard')"
                          class="mt-0 px-3"
                        >
                          <v-col>
                            <router-link
                              :to="/admin/.test(currentRouteName) ? '/admin' : '/settings'"
                              class="cursor-pointer"
                            >
                              <span :class="`caption ${currentRoute === 'dashboard' ? 'font-weight-bold' : ''}`">Dashboard</span>
                            </router-link>
                          </v-col>
                        </v-row>

                        <v-row
                          v-if="allowedRoutes.includes('enterprise')"
                          class="mt-0 px-3"
                        >
                          <v-col>
                            <router-link
                              to="/admin/enterprise"
                              class="cursor-pointer"
                            >
                              <span :class="`caption ${currentRoute === 'enterprise' ? 'font-weight-bold' : ''}`">Enterprise</span>
                            </router-link>
                          </v-col>
                        </v-row>

                        <v-row
                          v-if="allowedRoutes.includes('logs')"
                          class="mt-0 px-3"
                        >
                          <v-col>
                            <router-link
                              to="/admin/logs"
                              class="cursor-pointer"
                            >
                              <span :class="`caption ${currentRoute === 'logs' ? 'font-weight-bold' : ''}`">Logs</span>
                            </router-link>
                          </v-col>
                        </v-row>

                        <v-row
                          v-if="allowedRoutes.includes('security')"
                          class="mt-0 px-3"
                        >
                          <v-col>
                            <router-link
                              to="/admin/security"
                              class="cursor-pointer"
                            >
                              <span :class="`caption ${currentRoute === 'security' ? 'font-weight-bold' : ''}`">Security</span>
                            </router-link>
                          </v-col>
                        </v-row>

                        <v-row
                          v-if="allowedRoutes.includes('users')"
                          class="mt-0 px-3"
                        >
                          <v-col>
                            <router-link
                              to="/admin/users"
                              class="cursor-pointer "
                              active-class="primary--text"
                            >
                              <span :class="`caption ${currentRoute === 'users' ? 'font-weight-bold' : ''}`">Users</span>
                            </router-link>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <!-- Content -->
          <v-col>
            <v-card class="elevation-0">
              <v-card-text
                v-if="currentRoute === 'dashboard'"
                class="pa-6"
              >
                <v-row>
                  <AdminProfile />
                </v-row>
              </v-card-text>

              <v-card-text
                v-if="currentRoute === 'enterprise'"
                class="pa-6"
              >
                <v-row>
                  <AdminEnterprise />
                </v-row>
              </v-card-text>

              <v-card-text
                v-if="$route.params.reportName === 'security'"
                class="pa-6"
              >
                <v-row>
                  <AdminSecurity />
                </v-row>
              </v-card-text>

              <v-card-text
                v-if="$route.params.reportName === 'logs'"
                class="pa-6"
              >
                <v-row>
                  <AdminLog />
                </v-row>
              </v-card-text>

              <v-card-text
                v-if="$route.params.reportName === 'users'"
                class="pa-6"
              >
                <v-row>
                  <AdminUser />
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { createObject } from '@/utils/objects'

const { mapActions: mapAuthActions, mapGetters: mapAuthGetters, mapState: mapAuthState } = createNamespacedHelpers('auth')

export default {
  name: 'AdminApp',
  components: {
    AdminProfile: () => import('./AdminProfile.vue'),
    AdminUser: () => import('./AdminUser.vue'),
    AdminEnterprise: () => import('./AdminEnterprise.vue'),
    AdminSecurity: () => import('./AdminSecurity.vue'),
    AdminLog: () => import('./AdminLog.vue'),
  },
  data() {
    return {
      allowedRoutes: [],
      releasedRoutes: [
        {
          id: 'dashboard',
          grantAccess: (user) => user.hasCustomRoleAdmin,
        },
        {
          id: 'enterprise',
          grantAccess: (user) => user.hasCustomRoleAdmin,
        },
        {
          id: 'security',
          grantAccess: (user) => user.hasAccessToSecurityCenter,
        },
        {
          id: 'logs',
          grantAccess: (user) => user.hasAccessToLogs,
        },
        {
          id: 'users',
          grantAccess: (user) => user.hasAccessToUserManagement,
        },
      ],

      inputPassword: '',

      errorUpdatingPassword: '',
      successUpdatingPassword: false,
      showViewToUpdatePassword: false,

      users: [],
      userHeaders: [
        {
          sortable: true,
          text: 'Name',
          value: 'personName',
        },
        {
          sortable: true,
          text: 'Role',
          value: 'access.role',
        },
        {
          sortable: true,
          text: 'Email',
          value: 'docId',
        },
      ],
      userActions: [
        {
          text: 'Edit',
          value: 'editUser',
          icon: 'pencil',
        },
        {
          text: 'Update Password',
          value: 'updatePassword',
          icon: 'lock',
        },
        {
          text: 'Revoke Access',
          value: 'revokeAccess',
          icon: 'lock_open',
        },
      ],
      userForm: {},
      userEntry: {},
    }
  },
  computed: {
    ...mapAuthState({
      user: (state) => state.user,
    }),
    ...mapAuthGetters([
      'hasCustomRoleAdmin',
      'hasAccessToSecurityCenter',
      'isUserInternalDev',
    ]),
    currentRouteName() {
      return this.$route.name
    },
    currentRoute() {
      return this.$route.params.reportName
    },
    userEmail() {
      return (this.user && this.user.email) || ''
    },
  },
  created() {
    // eslint-disable-next-line arrow-body-style
    this.allowedRoutes = this.releasedRoutes.filter((routeConfig) => {
      return routeConfig.grantAccess(this.user)
    }).map((route) => route.id)
  },
  methods: {
    ...mapAuthActions([
      'updatePassword',
    ]),

    promptToUpdatePassword() {
      const { user } = this

      this.userForm = createObject(user, {
        actionType: 'update',
        objectType: 'password',
      })

      // Open a view that allows the user to update their password.
      this.showViewToUpdatePassword = true
    },

    cancelUpdatePassword() {
      // Close the view that allows the user to update their password.
      this.showViewToUpdatePassword = false

      // Clear the password input field.
      this.inputPassword = ''
    },

    handleUpdatePasswordError(message) {
      // Inform the user the password update was unsuccessful.
      this.$store.commit('tools/snackbar', true, { root: true })
      this.$store.commit('tools/snack', { message, status: 'error' }, { root: true })
    },

    async updateAuthPassword() {
      // Reset the success and error flags.
      this.errorUpdatingPassword = false
      this.successUpdatingPassword = false

      const domainName = this.userEmail.split('@')[1]

      // eslint-disable-next-line arrow-body-style
      const domainDoc = await this.$store.dispatch('auth/getDomainDocFromFirestore', domainName).catch((error) => {
        // Reset the registration state.
        this.handleUpdatePasswordError(error)
      })

      if (!domainDoc || domainDoc.error) {
        const defaultError = { code: '403', layer: 'app', message: 'Domain Error' }
        const error = domainDoc?.error || defaultError

        // Reset the registration state.
        return this.handleUpdatePasswordError(error)
      }

      // Handle inactive domains.
      if (!domainDoc.isActive) {
        const message = 'Domain Inactive'
        const error = { code: '403', layer: 'app', message }

        // Reset the registration state.
        return this.handleUpdatePasswordError(error)
      }

      // Save the domain document for later use by the provider selection dialog.
      this.domainDoc = domainDoc

      const updatePasswordData = {
        domainDoc,
        email: this.userEmail,
        password: this.inputPassword,
      }

      // Update the user's password.
      return this.$store.dispatch('auth/updatePassword', updatePasswordData).then((res) => {
        if (!res) {
          // Inform the user the password update was unsuccessful.
          return this.handleUpdatePasswordError('Error Updating Password')
        }

        if (res.error) {
          // Inform the user the password update was unsuccessful.
          return this.handleUpdatePasswordError(res.message)
        }

        // Inform the user the password update was successful.
        this.successUpdatingPassword = true

        return res
      }).catch((caughtError) => {
        // Set the error message for the "Update Password" view to display.
        this.errorUpdatingPassword = caughtError.message || 'Error updating password. If the problem persists, please contact support.'

        // Render the error message in the "Update Password" view.
        this.didUpdatePassword = true

        const messageMap = {
          'auth/requires-recent-login': 'Recent Login Required',
        }

        // Alert the user to the error.
        const { code, message: givenMessage } = caughtError || {}
        const rawMessage = givenMessage || 'Update Password Error'
        const message = messageMap[code] || rawMessage.replace('Firebase: ', 'Auth ')
        const actualError = caughtError || { code: '400', layer: 'app', message }

        // Inform the user the password update was unsuccessful.
        this.$store.commit('tools/snackbar', true, { root: true })
        this.$store.commit('tools/snack', { message, status: 'error' }, { root: true })

        // Return the error for further handling.
        return { error: actualError }
      })
    },

  },
}
</script>
